import InTransitJobDetail from './styled';

export default InTransitJobDetail;
